// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  font-family: "Open Sans", Arial, sans-serif;
}

.login-form-logo {
  margin: 15px 0;
}

.login-form-header {
  text-align: center;
  padding: 10px 0px 20px 0px;
  font-size: 20px;
  line-height: 20px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #4b4b4b;
}

.login-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 400px;
}

.login-form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  width: 100%;
}

.login-form-group label {
  vertical-align: middle;
  line-height: 0.5em;
  font-weight: bold;
  font-size: 12px;
  color: rgb(75, 75, 75);
}

.login-form-input-container {
  position: relative;
  padding: 0px 0px 0px 42px;
  background-color: white;
  border-radius: 4px;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow: rgb(155, 155, 155) 0px 0px 0px 1px;
  margin-top: 8px;
  width: calc(100% - 42px);
}

.login-form-input-container > svg {
  position: absolute;
  top: 0px;
  left: 0px;
  text-align: center;
  padding: 9px 6px;
}

.login-form-input-container input {
  display: block;
  width: 100%;
  box-sizing: border-box;
  line-height: 40px;
  height: 40px;
  border: none;
  outline: none;
  box-shadow: none;
  padding: 0px 40px 0px 0px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
}

.login-form-input-container input:disabled {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
}

.login-input.error {
  border: 1px solid rgb(222, 72, 88);
}

.login-error {
  color: rgb(222, 72, 88);
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

/* Hide browser's built-in password reveal button */
.login-form-input-container input[type="password"]::-ms-reveal,
.login-form-input-container input[type="password"]::-ms-clear {
  display: none;
}

.login-form-input-container input[type="password"]::-webkit-contacts-auto-fill-button,
.login-form-input-container input[type="password"]::-webkit-credentials-auto-fill-button {
  visibility: hidden;
  pointer-events: none;
  position: absolute;
  right: 0;
}

.password-toggle-button {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  transition: opacity 0.2s;
  width: 32px;
  height: 32px;
  line-height: 0;
  outline: none;
}

.password-toggle-button:focus {
  outline: none;
}

.password-toggle-button svg {
  display: block;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin: auto;
}

.password-toggle-button:hover {
  opacity: 1;
}

.login-form-reset-password {
  color: rgb(222, 72, 88);
  cursor: pointer;
  outline: none;
  text-decoration: none;
  font-weight: 600;
  font-size: 12px;
}

.login-button {
  box-sizing: border-box;
  padding: 0px 16px;
  margin: 0px;
  height: 36px;
  font-family: "Open Sans", Arial, sans-serif;
  font-weight: 500;
  color: white;
  text-transform: none;
  background: rgb(222, 72, 88);
  border-radius: 5px;
  border: none;
  outline: none;
  cursor: pointer;
  user-select: none;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
  min-width: 88px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
  width: 128px;
  opacity: 1;
  margin-top: 25px;
}

.login-wizard-button {
  box-sizing: border-box;
  padding: 0px 16px;
  margin: 0px;
  height: 36px;
  font-family: "Open Sans", Arial, sans-serif;
  font-weight: 500;
  color: white;
  text-transform: none;
  background: rgb(222, 72, 88);
  border-radius: 5px;
  border: none;
  outline: none;
  cursor: pointer;
  user-select: none;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
  min-width: 88px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
  width: 128px;
  opacity: 1;
  margin-top: 25px;
}

.login-wizard-button:disabled {
  background: rgb(155, 155, 155);
  color: rgb(75, 75, 75);
  cursor: default;
  box-shadow: none;
}

.login-wizard-button-row {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin-top: 16px;
}

/* Tablet breakpoint - reduce form width to prevent overlap with banner */
@media (max-width: 900px) {
  .login-form {
    width: 325px;
  }
}

/* Intermediate breakpoint - further reduce form width as space becomes constrained */
@media (max-width: 850px) {
  .login-form {
    width: 280px;
  }
}

/* Mobile breakpoint - hide banner, smaller form (matches NetSfere behavior) */
@media (max-width: 800px) {
  .login-form {
    width: 275px;
    margin: 0 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Login/LoginForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,gDAAgD;EAChD,8CAA8C;EAC9C,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,mDAAmD;AACnD;;EAEE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gDAAgD;EAChD,eAAe;EACf,4EAA4E;EAC5E,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gDAAgD;EAChD,eAAe;EACf,4EAA4E;EAC5E,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE;IACE,YAAY;EACd;AACF;;AAEA,qFAAqF;AACrF;EACE;IACE,YAAY;EACd;AACF;;AAEA,8EAA8E;AAC9E;EACE;IACE,YAAY;IACZ,cAAc;EAChB;AACF","sourcesContent":[".login-form-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  font-family: \"Open Sans\", Arial, sans-serif;\n}\n\n.login-form-logo {\n  margin: 15px 0;\n}\n\n.login-form-header {\n  text-align: center;\n  padding: 10px 0px 20px 0px;\n  font-size: 20px;\n  line-height: 20px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  color: #4b4b4b;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 400px;\n}\n\n.login-form-group {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 16px;\n  width: 100%;\n}\n\n.login-form-group label {\n  vertical-align: middle;\n  line-height: 0.5em;\n  font-weight: bold;\n  font-size: 12px;\n  color: rgb(75, 75, 75);\n}\n\n.login-form-input-container {\n  position: relative;\n  padding: 0px 0px 0px 42px;\n  background-color: white;\n  border-radius: 4px;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  box-shadow: rgb(155, 155, 155) 0px 0px 0px 1px;\n  margin-top: 8px;\n  width: calc(100% - 42px);\n}\n\n.login-form-input-container > svg {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  text-align: center;\n  padding: 9px 6px;\n}\n\n.login-form-input-container input {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  line-height: 40px;\n  height: 40px;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  padding: 0px 40px 0px 0px;\n  font-family: Roboto, sans-serif;\n  font-size: 14px;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.login-form-input-container input:disabled {\n  background-color: #f5f5f5;\n  color: #666;\n  cursor: not-allowed;\n}\n\n.login-input.error {\n  border: 1px solid rgb(222, 72, 88);\n}\n\n.login-error {\n  color: rgb(222, 72, 88);\n  font-size: 12px;\n  margin-top: 4px;\n  display: block;\n}\n\n/* Hide browser's built-in password reveal button */\n.login-form-input-container input[type=\"password\"]::-ms-reveal,\n.login-form-input-container input[type=\"password\"]::-ms-clear {\n  display: none;\n}\n\n.login-form-input-container input[type=\"password\"]::-webkit-contacts-auto-fill-button,\n.login-form-input-container input[type=\"password\"]::-webkit-credentials-auto-fill-button {\n  visibility: hidden;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n}\n\n.password-toggle-button {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n  width: 32px;\n  height: 32px;\n  line-height: 0;\n  outline: none;\n}\n\n.password-toggle-button:focus {\n  outline: none;\n}\n\n.password-toggle-button svg {\n  display: block;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  margin: auto;\n}\n\n.password-toggle-button:hover {\n  opacity: 1;\n}\n\n.login-form-reset-password {\n  color: rgb(222, 72, 88);\n  cursor: pointer;\n  outline: none;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.login-button {\n  box-sizing: border-box;\n  padding: 0px 16px;\n  margin: 0px;\n  height: 36px;\n  font-family: \"Open Sans\", Arial, sans-serif;\n  font-weight: 500;\n  color: white;\n  text-transform: none;\n  background: rgb(222, 72, 88);\n  border-radius: 5px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  user-select: none;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  min-width: 88px;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;\n  width: 128px;\n  opacity: 1;\n  margin-top: 25px;\n}\n\n.login-wizard-button {\n  box-sizing: border-box;\n  padding: 0px 16px;\n  margin: 0px;\n  height: 36px;\n  font-family: \"Open Sans\", Arial, sans-serif;\n  font-weight: 500;\n  color: white;\n  text-transform: none;\n  background: rgb(222, 72, 88);\n  border-radius: 5px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  user-select: none;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  min-width: 88px;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;\n  width: 128px;\n  opacity: 1;\n  margin-top: 25px;\n}\n\n.login-wizard-button:disabled {\n  background: rgb(155, 155, 155);\n  color: rgb(75, 75, 75);\n  cursor: default;\n  box-shadow: none;\n}\n\n.login-wizard-button-row {\n  display: flex;\n  justify-content: space-evenly;\n  width: 100%;\n  margin-top: 16px;\n}\n\n/* Tablet breakpoint - reduce form width to prevent overlap with banner */\n@media (max-width: 900px) {\n  .login-form {\n    width: 325px;\n  }\n}\n\n/* Intermediate breakpoint - further reduce form width as space becomes constrained */\n@media (max-width: 850px) {\n  .login-form {\n    width: 280px;\n  }\n}\n\n/* Mobile breakpoint - hide banner, smaller form (matches NetSfere behavior) */\n@media (max-width: 800px) {\n  .login-form {\n    width: 275px;\n    margin: 0 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
